import React from "react";
import styles from "./EmojiPicker.module.css";

const COMMON_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏", "🔥", "✅", "🎉", "✨"];

export default function EmojiPicker({ onSelect }) {
  return (
    <div className={styles.picker}>
      <div className={styles.grid}>
        {COMMON_EMOJIS.map((emoji) => (
          <button
            key={emoji}
            className={styles.emojiBtn}
            onClick={() => onSelect(emoji)}
            type="button"
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}
